import get11AgentInfo from '../ecdn11/get11AgentInfo';
import logger from '../log';
import racedPromise from '../common/utils/racedPromise';
import { BasePromiseData } from './interfaces';
import { addDuration } from '../common/utils/duration';
import { ElevenAgentData } from '../ecdn11/interfaces';

const log = logger.getLogger(__filename);
export type OptionalElevenData = ElevenAgentData | undefined;

const get11Data = (obj: BasePromiseData): Promise<OptionalElevenData> => {
  const { base, config, vals } = obj;
  const controller = new AbortController();
  return racedPromise({
    ...base,
    callback: value => {
      log.debug('11 Agent finished: ', { value });
      addDuration({ vals, key: '11' });
    },
    controller,
    promise: get11AgentInfo(config, controller)
  });
};

export default get11Data;
